/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Modal } from 'antd';
import { auth } from 'utils/auth';
import { getUploadErrorMessage, openNotificationWithIcon } from 'utils';

export const TOAST_ERROR_STATUS = [-4005];

const logoutClose = async () => {
  await auth.logout();
};

const formatMessageWithLineBreaks = (message: string) => {
  if (!message) return message;

  const lines = message.split('\n');
  return (
    <>
      {lines.map((line, index) => (
        <span key={index}>
          {line}
          {index < lines.length - 1 && <br />}
        </span>
      ))}
    </>
  );
};

export const errorBind = (status) => {
  /* -2306 : 토큰시간초과, -2302 : 인증정보없음, -2303 : 인증정보만료, -2304 : 토큰정보가 없음, -511 : 하위계정 로그인 제한 */
  const data = {
    '-2300': {
      // -2300 : 다시로그인
      redirect: '/',
      stopBubble: true,
      close: logoutClose
    },
    '-2302': {
      // -2302 : 인증정보없음
      redirect: '/',
      stopBubble: true,
      close: logoutClose
    },
    '-2303': {
      // -2303 : 인증정보만료
      redirect: '/',
      stopBubble: true,
      close: logoutClose
    },
    '-2304': {
      // -2304 : 토큰정보가 없음
      redirect: '/',
      stopBubble: true,
      close: logoutClose
    },
    '-2306': {
      // -2306 : 토큰시간초과
      open: false,
      refresh: true
    },
    '-511': {
      // -511 : 하위계정 로그인 제한
      redirect: '/changePassword'
    }
  };
  return data[status];
};

const route = ({ redirect, routeTo }) => {
  if (redirect) {
    window.location.href = redirect;
    // eslint-disable-next-line no-empty
  } else if (routeTo) {
  }
};

const handler = (error) => {
  const response = error?.response;
  if (response?.status === 500 || response?.status === 400 || response?.status === 401) {
    const { status, message: content, error: responseError, title } = response?.data || {};

    // 토스트 대상 코드는 서버 메시지를 그대로 노출하고 종료 (인터셉터/훅 onError 중복 호출 대비 key로 1개만 유지)
    if (TOAST_ERROR_STATUS.includes(status)) {
      openNotificationWithIcon({
        message: responseError?.message || content || error?.message,
        type: 'error',
        duration: 4.5,
        key: `error-status-${status}`
      });
      return;
    }

    const bindError = errorBind(status);
    if (bindError) {
      const { redirect, routeTo, open = true, close, nothing } = bindError;
      if (nothing) return;

      if (open) {
        Modal.warning({
          title,
          content: formatMessageWithLineBreaks(responseError?.message || content || error?.message),
          // icon: <ExclamationCircleOutlined />,
          okText: '확인',
          className: 'error-handler-modal',
          zIndex: 20000,
          // cancelButtonProps: { style: { display: 'none' } },
          onOk: async () => {
            if (close) await close();
            route({ redirect, routeTo });
          }
        });
      } else {
        // if(close) close();
        // route({redirect, routeTo})
        Modal.warning({
          title,
          content: formatMessageWithLineBreaks(responseError?.message || content || error?.message),
          // icon: <ExclamationCircleOutlined />,
          okText: '확인',
          className: 'error-handler-modal',
          zIndex: 20000
          // cancelButtonProps: { style: { display: 'none' } },
          // onOk: () => {}
        });
      }
    } else {
      Modal.warning({
        // title: 'error',
        content: formatMessageWithLineBreaks(responseError?.message || content || error?.message),
        icon: null,
        okText: '확인',
        className: 'error-handler-modal',
        zIndex: 20000
        // cancelButtonProps: { style: { display: 'none' } },
        // onOk: () => {}
      });
    }
  }
};

// 업로드 흐름 에러 노출 — handler가 다루지 않는 응답·네트워크·S3 업로드 실패도 묻히지 않도록
export const showUploadError = (error) => {
  const message = getUploadErrorMessage(error);
  if (message === null) {
    handler(error);
    return;
  }
  Modal.warning({
    content: message,
    icon: null,
    okText: '확인',
    className: 'error-handler-modal',
    zIndex: 20000
  });
};

export default handler;
